import { lightShadows2 } from './shadows'

declare module '@mui/material/styles' {
	interface PaletteColor {
		lighter?: string
		darker?: string
	}
	interface SimplePaletteColorOptions {
		lighter?: string
		darker?: string
	}
}

const colorSchemes = {
	light: {
		// 👇 palette values for light mode
		palette: {
			common: {
				black: '#000',
				white: '#fff',
			},
			primary: {
				light: '#4D65B4',
				main: '#303E6F',
				dark: '#17234B',
				contrastText: '#fff',
			},
			secondary: {
				lighter: '#F6DAE6',
				light: '#ED6FA5',
				main: '#C04B7B',
				dark: '#BC044F',
				contrastText: '#fff',
			},
			error: {
				light: '#EEA0A0',
				main: '#E36060',
				dark: '#E82626',
				contrastText: '#fff',
			},
			warning: {
				light: '#ECA074',
				main: '#E06017',
				dark: '#E06017',
				contrastText: '#fff',
			},
			success: {
				light: '#74D7B4',
				main: '#18BD82',
				dark: '#00905D',
				contrastText: '#fff',
			},
			text: {
				primary: '#060D21',
				secondary: '#5F6272',
				disabled: '#8D8D90',
			},
			background: {
				paper: '#fff',
				default: '#FAFAFA',
			},
		},
		shadows: lightShadows2,
	},
	dark: {
		palette: {
			common: {
				black: '#000',
				white: '#fff',
			},
			primary: {
				light: '#4D65B4',
				main: '#5C6FC0',
				dark: '#354587',
				contrastText: '#fff',
			},
			secondary: {
				lighter: '#E7CBEC',
				light: '#ED6FA5',
				main: '#CE93D8',
				dark: '#AB47BC',
				contrastText: '#000',
			},
			background: {
				paper: '#141317',
				default: '#201F25',
			},
			paperBackgrounds: [
				'#141317',
				'#24232A',
				'#26252D',
				'#282730',
				'#2A2933',
				'#2C2B36',
				'#2E2D39',
				'#302F3C',
				'#32313F',
				'#343342',
				'#363545',
				'#393848',
				'#3B3A4B',
				'#3D3C4E',
				'#414054',
				'#434257',
				'#454455',
				'#474657',
				'#494A5A',
				'#4B4C5D',
				'#4D4E60',
				'#515264',
				'#535467',
				'#55566A',
				// darker color for dialogs
				'#343342',
			],
			grey: {
				50: '#0C0C0E',
				100: '#18171C',
				200: '#302E38',
				300: '#484653',
				400: '#605D6F',
				500: '#78748B',
				600: '#9390A2',
				700: '#AEACB9',
				800: '#C9C7D1',
				900: '#E4E3E8',
			},
		},
		overlays: Array(25).fill('none'),
		shadows: Array(25).fill('none'),
	},
}

export default colorSchemes
